import { formatDate, formatDateTime } from '../../../../utils/date';
import { round2Format } from '../../../../utils/number';

type Nullable<T> = T | null | undefined;

const upTo8Formatter = Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 8 });

/**
 * Execution values are null until Derayah reports the leg, and zero is a real
 * post-execution value — so null is returned as-is (rendered as "—" by `Field`)
 * and never collapsed to 0.
 */
const isMissing = (value: unknown): value is null | undefined | '' =>
  value === null || value === undefined || value === '';

export const formatSar = (value: Nullable<number>) => {
  if (isMissing(value)) return null;
  return `${round2Format(Number(value))} SAR`;
};

/** NAV and units: up to 8 decimals. */
export const formatUpTo8 = (value: Nullable<number>) => {
  if (isMissing(value)) return null;
  return upTo8Formatter.format(Number(value));
};

export const formatOptionalDate = (value: Nullable<string>) => (value ? formatDate(value) : null);

export const formatOptionalDateTime = (value: Nullable<string>) => (value ? formatDateTime(value) : null);

/** bigint refs may arrive as strings or numbers; only ever stringify them. */
export const formatRef = (value: Nullable<string | number>) => {
  if (isMissing(value)) return null;
  return String(value);
};
